module.exports = __webpack_public_path__ + "media/images/icons/redeem-47963dfb18513a03313d0af8973df266.svg";